import classNames from "classnames";
import type { FC } from "react";

/** Play-button overlay for file-video posters in the product carousel. */
const PlayIcon: FC<{ compact?: boolean }> = ({ compact }) => {
  const size = compact ? 16 : 28;
  return (
    <div
      className={classNames("product-carousel__play-icon", {
        "product-carousel__play-icon--compact": compact,
      })}
      role="presentation"
      aria-hidden
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M8 5v14l11-7z" />
      </svg>
    </div>
  );
};

export default PlayIcon;
